/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import React, { useEffect, useState } from "react";
import { IoBagHandle } from "react-icons/io5";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { FiDollarSign } from "react-icons/fi";
import { CiCalendarDate, CiClock2 } from "react-icons/ci";
import moment from "moment";
import { useForm } from "react-hook-form";
import ButtonAll from "../button/Button";
import useAuthUser from "../../auth/getUser";
 
const JobApply = () => {
  const navigate = useNavigate();
  const {user} = useAuthUser();
  const [job, setJob] = useState([]);
  const [loading, setLoading] = useState([]);
  const { id } = useParams();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
   
  } = useForm();
  const [isApplied, setApplied] = useState();
  console.log(job)

  useEffect(() => { 
    fetch(`${process.env.REACT_APP_BASE_API}/postjobs/${id}`)
      .then(res=>res.json())
      .then(data=> {
        data?.totalApplicant?.map(
          (item) => {
            if(item.applicant._id === user?._id) setApplied(true)
              // console.log("isapplied",isApplied)
          }
        );
      })
   },[user])
  
  const onSubmit = async (data) => {
    console.log(data);
    const {subject,message,contact_info} = data;
    const res = await axios.get(`${process.env.REACT_APP_BASE_API}/postjobs/${id}`);
    // console.log("job detailsssssssssssssssssssssssss ", res.data.totalApplicant)

    //  res.data?.totalApplicant?.map(
    //   (item) => {
    //     if(item.applicant._id === user?._id) setApplied(true)
    //       console.log(isApplied)
    //   }
    // );

    // console.log("this is isApplied", isApplied);

    if(isApplied)
    {
      Swal.fire({
        position: "top",
        icon: "success",
        title: "Already applied this job!",
        showConfirmButton: false,
        timer: 1500,
      })
      return;
    }
    const { job_title, job_type, job_description,_id , postbyId} = res?.data;
    const alldata = {
      employer_name: user?.name,
      job_title,
      job_type,
      job_post: job_description,
      status: "active",
      subject,
      message,
      contact_info,
      jobCreator: postbyId,
    };

    // console.log(alldata);

    const po = await axios.post(
      `${process.env.REACT_APP_BASE_API}/application`,
      alldata
    );
    if (po?.data) {
      const res = await axios.put(`${process.env.REACT_APP_BASE_API}/postjobs/${id}?applicantId=${user._id}&status=awaiting`);
      console.log("from job apppppppply",res.data)
      Swal.fire({
        position: "top",
        icon: "success",
        title: "Your apply job saved",
        showConfirmButton: false,
        timer: 1500,
      },
    reset());
    navigate(`/apply-success/${_id}`);
    }

  };


  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_API}/postjobs/${id}`
        );
        setJob(res.data);
        setLoading(false);
      } catch (error) {
        console.error("There was an error fetching the jobs!", error);
        Swal.fire({
          title: "Error!",
          text: "There was an error fetching the jobs",
          icon: "error",
          confirmButtonText: "OK",
        });
        setLoading(false);
      }
    };

    fetchJobs();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  // const handleApply = async (id) => {
   
  // };

  // console.log("rthis is job single", job)

  return (
    <div className=" max-w-4xl mx-auto my-16">
      <div>
        <h2 className="text-3xl leading-[120%] capitalize"> {job.job_headline}</h2>
        <p className=" text-xs my-2">
          By <span className="text-[#2792A8] ">{job.postby}</span>
        </p>
      </div>

      <div className="flex gap-3 mt-5">
        <div className="flex gap-2 items-center border border-base-300 rounded-xl px-4 py-2">
          <div>
            <IoBagHandle className="text-2xl text-[#2792A8]" />
          </div>
          <div>
            <h2>Type of work</h2>
            <h2 className="text-[24px] font-semibold">Full Time</h2>
          </div>
        </div>

        <div className="flex gap-2 items-center border border-base-300 rounded-xl px-4 py-2">
          <div>
            <FiDollarSign className="text-2xl text-[#2792A8]" />
          </div>
          <div>
            <h2>Salary</h2>
            <h2 className="text-[24px] font-semibold">${job.salary}</h2>
          </div>
        </div>

        <div className="flex gap-2 items-center border border-base-300 rounded-xl px-4 py-2">
          <div>
            <CiClock2 className="text-2xl text-[#2792A8]" />
          </div>
          <div>
            <h2>Hour per week</h2>
            <h2 className="text-[24px] font-semibold">{job.hour_per_week}</h2>
          </div>
        </div>

        <div className="flex gap-2 items-center border border-base-300 rounded-xl px-4 py-2">
          <div>
            <CiCalendarDate className="text-2xl text-[#2792A8]" />
          </div>
          <div>
            <h2>Date Posted</h2>
            <h2 className="text-[24px] font-semibold">
              {moment(job.createdAt).format("MMMM Do YYYY,")}
            </h2>
          </div>
        </div>
      </div>
      
      <div className="bg-[#EDF7F4] mt-5 p-5 rounded-lg">
       <h2 className="text-4xl font-semibol text-[#196D7C] my-2"> Job description</h2>
        <form onSubmit={handleSubmit(onSubmit)} className="">
          <div className="form-control">
            <label className="label">
              <span className="label-text font-semibold">Subject</span>
            </label>
            <input
              type="text"
              placeholder="SUbject"
              className="input input-sm input-bordered rounded-2xl"
              {...register("subject", { required: "Subject is required" })}
            />
            {errors.subject && (
              <span className="text-red-500">{errors.subject.message}</span>
            )}
          </div>
          <div className="form-control">
            <label className="label">
              <span className="label-text font-semibold">Message</span>
            </label>
            <textarea
              className="textarea textarea-bordered"
              {...register("message", { required: "Message is required" })}
              placeholder="Message"
            />

            {errors.subject && (
              <span className="text-red-500">{errors.subject.message}</span>
            )}
          </div>

          <div className="form-control">
            <div className="flex justify-between">
              <label className="label">
                <span className="label-text font-semibold">Contact Info</span>
              </label>
            </div>
            <input
              type="text"
              placeholder="Contact info"
              className="input input-sm input-bordered rounded-2xl"
              {...register("contact_info", {
                required: "Contact info is required",
              })}
            />
            {errors.password && (
              <span className="text-red-500">{errors.password.message}</span>
            )}
          </div>

          <div className="form-control mt-6">

            <ButtonAll type="submit">
                Send By Mail
            </ButtonAll>
          </div>
        </form>
      </div>
    </div>
  );
};

export default JobApply;
